import AlarmOffRoundedIcon from '@mui/icons-material/AlarmOffRounded'
import HistoryIcon from '@mui/icons-material/History'
import type { PopoverOrigin } from '@mui/material/Popover'

import { createBadge } from '@util/kpi-util'

import { Kpi } from '../../aansluiting/project/components/Kpi'
import type { Project } from '../../aansluiting/project/types/Project'
import type { HoofdleidingProject } from '../../hoofdleiding/project/types/HoofdleidingProject'
import { StyledIconButton } from '../../theme/components/StyledIconButton'

export { Status }

interface Props {
  project: Project | HoofdleidingProject
  placement?: PopoverOrigin['horizontal']
}

const Status = ({ project, placement }: Props) => {
  const badge = project.kpi && createBadge(project.kpi)
  const { isActive, isDirty } = project

  if (!isActive) {
    return (
      <StyledIconButton title="Niet actief" icon={<AlarmOffRoundedIcon />} />
    )
  }

  if (isActive && isDirty) {
    return (
      <StyledIconButton
        title="Door wijzigingen wordt project herberekend"
        icon={<HistoryIcon />}
      />
    )
  }

  return badge ? <Kpi project={project} placement={placement} /> : null
}
